var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('TopTabs',{attrs:{"list":this.$nav6}}),_c('div',{staticClass:"video-box"},[_c('video',{staticClass:"myVideo",attrs:{"autoplay":"autoplay","muted":"","controls":"","src":_vm.$route.query.url,"type":"video/mp4"},domProps:{"muted":true}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }